/**
 * The modeller shell: one layout, six screens.
 *
 * A 220px black rail on the left and a white content column — measured from
 * 1a, which puts the nav at `width:220px` and the page gutter at 20px. Every
 * modeller screen lives inside this; there are not six page layouts.
 */

import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { modeller } from '../api';
import '../tokens.css';
import './shell.css';

const NAV = [
  { to: '/modeller/productions', label: 'Productions' },
  { to: '/modeller/equipment', label: 'Equipment library' },
];

export function Shell({ children }: { children: ReactNode }) {
  return (
    <div className="pem pem-shell">
      <nav className="pem-rail" aria-label="Modeller">
        <div className="pem-rail__brand">
          <img src="/equoia-feathers-600.png" alt="" width={26} height={26} />
          <span>Predictive Energy Modeller</span>
        </div>
        <div className="pem-rail__items">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                isActive ? 'pem-rail__item pem-rail__item--active' : 'pem-rail__item'
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
        {/* Fixture mode is stated, always. A demo screen that looks like the
            real thing is how a screenshot of invented numbers escapes. */}
        {modeller.mode === 'fixture' && (
          <div className="pem-rail__mode" role="status">
            Development fixtures — not live data
          </div>
        )}
      </nav>
      <main className="pem-content">{children}</main>
    </div>
  );
}

/** The page header: title left, actions right, on the 20px gutter. */
export function PageHeader(
  { title, count, actions }: { title: string; count?: string; actions?: ReactNode },
) {
  return (
    <header className="pem-pagehead">
      <div className="pem-pagehead__titles">
        <h1>{title}</h1>
        {count && <span className="pem-label">{count}</span>}
      </div>
      {actions && <div className="pem-pagehead__actions">{actions}</div>}
    </header>
  );
}
